// @ts-nocheck

import { request } from '../../../../../context';
import type { ApiOptions } from '../../../../../context';
import type {
    BaseResponseWebPagePluginConfig,
    PostCompanysIntelligentPartnerWebPagePluginBody,
    BaseResponseVoid,
} from '../../../../../types';

/**
 * 获取陪练网页插件
 *
 * @export
 * @tags 租户接口
 * @link [GET] /companys/intelligent/partner/webPage/plugin
 */
export function getCompanysIntelligentPartnerWebPagePlugin(): Promise<BaseResponseWebPagePluginConfig>;
export function getCompanysIntelligentPartnerWebPagePlugin(
    options: ApiOptions<never, never>
): Promise<BaseResponseWebPagePluginConfig>;
export function getCompanysIntelligentPartnerWebPagePlugin(
    options?: ApiOptions<never, never>
): Promise<BaseResponseWebPagePluginConfig> {
    return request<never, never, never>('/companys/intelligent/partner/webPage/plugin', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getCompanysIntelligentPartnerWebPagePlugin',
    });
}

/**
 * 保存陪练网页插件
 *
 * @export
 * @tags 租户接口
 * @link [POST] /companys/intelligent/partner/webPage/plugin
 */
export function postCompanysIntelligentPartnerWebPagePlugin(
    data: PostCompanysIntelligentPartnerWebPagePluginBody
): Promise<BaseResponseVoid>;
export function postCompanysIntelligentPartnerWebPagePlugin(
    data: PostCompanysIntelligentPartnerWebPagePluginBody,
    options: ApiOptions<never, never>
): Promise<BaseResponseVoid>;
export function postCompanysIntelligentPartnerWebPagePlugin(
    data: PostCompanysIntelligentPartnerWebPagePluginBody,
    options?: ApiOptions<never, never>
): Promise<BaseResponseVoid> {
    return request<PostCompanysIntelligentPartnerWebPagePluginBody, never, never>(
        '/companys/intelligent/partner/webPage/plugin',
        {
            ...options,
            data,
            method: 'post',
            __$requestCalleeName: 'postCompanysIntelligentPartnerWebPagePlugin',
        }
    );
}

export const meta = [
    { tags: ['租户接口'], path: '/companys/intelligent/partner/webPage/plugin', method: 'get' },
    { tags: ['租户接口'], path: '/companys/intelligent/partner/webPage/plugin', method: 'post' },
];
